import { cleanContentfulId } from '@telialt/utils/src/Contentful/cleanContentfulId';

import { BlockTextType } from '../../models/Content';
import { BlockTextContent } from './model';

export const transformBlockText = (content: BlockTextType): BlockTextContent => {
    return {
        id: content.sys.id,
        description: content.fields.description,
        colorOption: cleanContentfulId(content.fields.colorOption),
    };
};
